import React, {createContext, useMemo} from 'react'
import {PartnerAdministrator, Partner} from '@common/models'

import {useGetCurrentPartnerAdministrator} from '~/api/partnerAdministrator'

type PartnerAdministratorContextType = {
  partnerAdministrator: PartnerAdministrator | undefined
  partner: Partner | undefined
  isLoading: boolean
}

export const PartnerAdministratorContext =
  createContext<PartnerAdministratorContextType>({
    partnerAdministrator: undefined,
    partner: undefined,
    isLoading: true,
  })

type PartnerAdministratorContextProviderProps = {
  children: React.ReactNode
}

export const PartnerAdministratorContextProvider: React.FC<
  PartnerAdministratorContextProviderProps
> = ({children}) => {
  const {data: partnerAdministrator, isLoading} =
    useGetCurrentPartnerAdministrator()

  const contextValue = useMemo(
    () => ({
      partnerAdministrator,
      partner: partnerAdministrator?.partner,
      isLoading,
    }),
    [partnerAdministrator, isLoading],
  )

  return (
    <PartnerAdministratorContext.Provider value={contextValue}>
      {children}
    </PartnerAdministratorContext.Provider>
  )
}
